import React, { useEffect, useState } from 'react';
import TextInput from '@havenengineering/module-shared-library/dist/form/components/TextInput';
import {
  InputProps,
  wrapField,
} from '@havenengineering/module-shared-library/dist/form/hooks/useForm';

const SortCodeInput = (props: InputProps<string>) => {
  const [sortCode, setSortCode] = useState(props.value || '');
  const setSortCodeWithMask = (value: string) => {
    setSortCode(() =>
      value
        .replace(/^([0-9]{2})$/g, '$1-')
        .replace(/^([0-9]{2})-([0-9]{2})$/g, '$1-$2-')
    );
  };

  useEffect(() => {
    props.onChange(sortCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortCode]);

  return (
    <TextInput
      className="fs-mask"
      {...props}
      value={sortCode}
      onChange={(value) => {
        if (value.length < sortCode.length) {
          setSortCode(value);
          return;
        }
        setSortCodeWithMask(value);
      }}
    />
  );
};
const SortCodeInputField = wrapField(SortCodeInput);
export default SortCodeInputField;
